import { IPoLScoring, LIFE_TEST_ID, SCORING_TYPE, SCORING_PARAMETER } from '../../models/life-check';

export const scoring: IPoLScoring = {
	[LIFE_TEST_ID.MIDDLEFACE]: {
		[SCORING_PARAMETER.PercentageTimeInTheMiddle]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 20 },
				{ value: 2.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 7.5, min: 40, max: 60 },
				{ value: 10, min: 60, max: 100 },
			],
			weight: 30,
		},
		[SCORING_PARAMETER.SimilarityPercentage]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 50 },
				{ value: 5, min: 50, max: 60 },
				{ value: 10, min: 60, max: 80 },
				{ value: 7.5, min: 80, max: 95 },
				{ value: 0, min: 95, max: 100 },
			],
			weight: 40,
		},
		[SCORING_PARAMETER.TotalTries]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 10, min: 1, max: 1 },
				{ value: 5, min: 1, max: 2 },
			],
			weight: 15,
		},
		[SCORING_PARAMETER.TotalTime]: {
			type: SCORING_TYPE.Time,
			ranges: [
				{ value: 10, min: 0, max: 20 },
				{ value: 7.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 0, min: 40, max: null },
			],
			weight: 15,
		},
	},
	[LIFE_TEST_ID.SMILE]: {
		[SCORING_PARAMETER.Emotion]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 30 },
				{ value: 7.5, min: 30, max: 40 },
				{ value: 10, min: 40, max: 75 },
				{ value: 5, min: 75, max: 100 },
			],
			weight: 20,
		},
		[SCORING_PARAMETER.MaxEmotion]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 50 },
				{ value: 7.5, min: 50, max: 75 },
				{ value: 10, min: 75, max: 100 },
			],
			weight: 10,
		},
		[SCORING_PARAMETER.EmotionTransition]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 0, min: 0, max: 4 },
				{ value: 5, min: 4, max: 7 },
				{ value: 10, min: 7, max: 10 },
			],
			weight: 20,
		},
		[SCORING_PARAMETER.SimilarityPercentage]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 50 },
				{ value: 5, min: 50, max: 60 },
				{ value: 10, min: 60, max: 80 },
				{ value: 7.5, min: 80, max: 95 },
				{ value: 0, min: 95, max: 100 },
			],
			weight: 15,
		},
		[SCORING_PARAMETER.PercentageTimeInTheMiddle]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 20 },
				{ value: 2.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 7.5, min: 40, max: 60 },
				{ value: 10, min: 60, max: 100 },
			],
			weight: 15,
		},
		[SCORING_PARAMETER.TotalTime]: {
			type: SCORING_TYPE.Time,
			ranges: [
				{ value: 10, min: 0, max: 20 },
				{ value: 7.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 0, min: 40, max: 60 },
			],
			weight: 10,
		},
		[SCORING_PARAMETER.TotalTries]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 10, min: 1, max: 1 },
				{ value: 5, min: 1, max: 2 },
			],
			weight: 10,
		},
	},
	[LIFE_TEST_ID.APPROACHFACE]: {
		[SCORING_PARAMETER.FinalScore]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 45 },
				{ value: 5, min: 45, max: 60 },
				{ value: 7.5, min: 60, max: 80 },
				{ value: 10, min: 80, max: 100 },
			],
			weight: 35,
		},
		[SCORING_PARAMETER.ShapeScore]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 45 },
				{ value: 5, min: 45, max: 60 },
				{ value: 7.5, min: 60, max: 80 },
				{ value: 10, min: 80, max: 100 },
			],
			weight: 20,
		},
		[SCORING_PARAMETER.AppearanceScore]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 45 },
				{ value: 5, min: 45, max: 60 },
				{ value: 7.5, min: 60, max: 80 },
				{ value: 10, min: 80, max: 100 },
			],
			weight: 20,
		},
		[SCORING_PARAMETER.DepthDelta]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 40 },
				{ value: 5, min: 40, max: 60 },
				{ value: 10, min: 60, max: 85 },
				{ value: 7.5, min: 85, max: 100 },
			],
			weight: 10,
		},
		[SCORING_PARAMETER.PercentageTimeInTheMiddle]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 20 },
				{ value: 2.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 7.5, min: 40, max: 60 },
				{ value: 10, min: 60, max: 100 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.TotalTime]: {
			type: SCORING_TYPE.Time,
			ranges: [
				{ value: 10, min: 0, max: 20 },
				{ value: 7.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 0, min: 40, max: 60 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.TotalTries]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 10, min: 1, max: 1 },
				{ value: 5, min: 1, max: 2 },
			],
			weight: 5,
		},
	},
	[LIFE_TEST_ID.TURNRIGHTHEAD]: {
		[SCORING_PARAMETER.Emotion]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 30 },
				{ value: 7.5, min: 30, max: 40 },
				{ value: 10, min: 40, max: 75 },
				{ value: 5, min: 75, max: 100 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.MaxEmotion]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 50 },
				{ value: 10, min: 50, max: 75 },
				{ value: 7.5, min: 75, max: 100 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.EmotionTransition]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 0, min: 0, max: 4 },
				{ value: 5, min: 4, max: 7 },
				{ value: 10, min: 7, max: 10 },
			],
			weight: 10,
		},
		[SCORING_PARAMETER.SimilarityPercentage]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 50 },
				{ value: 5, min: 50, max: 60 },
				{ value: 10, min: 60, max: 80 },
				{ value: 7.5, min: 80, max: 95 },
				{ value: 0, min: 95, max: 100 },
			],
			weight: 10,
		},
		[SCORING_PARAMETER.PercentageTimeInTheMiddle]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 20 },
				{ value: 2.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 7.5, min: 40, max: 60 },
				{ value: 10, min: 60, max: 100 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.TotalTime]: {
			type: SCORING_TYPE.Time,
			ranges: [
				{ value: 10, min: 0, max: 20 },
				{ value: 7.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 0, min: 40, max: 60 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.TotalTries]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 10, min: 1, max: 1 },
				{ value: 5, min: 1, max: 2 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.NoseDistance]: {
			type: SCORING_TYPE.Pixel,
			ranges: [
				{ value: 0, min: 0, max: 70 },
				{ value: 7.5, min: 70, max: 90 },
				{ value: 10, min: 90, max: 130 },
				{ value: 7.5, min: 130, max: 150 },
				{ value: 5, min: 150, max: null },
			],
			weight: 20,
		},
		[SCORING_PARAMETER.NoseTransition]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 0, min: 0, max: 4 },
				{ value: 5, min: 4, max: 7 },
				{ value: 10, min: 7, max: 10 },
			],
			weight: 15,
		},
		[SCORING_PARAMETER.NoseVariance]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 60 },
				{ value: 7.5, min: 60, max: 75 },
				{ value: 10, min: 75, max: 100 },
			],
			weight: 20,
		},
	},
	[LIFE_TEST_ID.TURNLEFTHEAD]: {
		[SCORING_PARAMETER.Emotion]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 30 },
				{ value: 7.5, min: 30, max: 40 },
				{ value: 10, min: 40, max: 75 },
				{ value: 5, min: 75, max: 100 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.MaxEmotion]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 50 },
				{ value: 10, min: 50, max: 75 },
				{ value: 7.5, min: 75, max: 100 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.EmotionTransition]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 0, min: 0, max: 4 },
				{ value: 5, min: 4, max: 7 },
				{ value: 10, min: 7, max: 10 },
			],
			weight: 10,
		},
		[SCORING_PARAMETER.SimilarityPercentage]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 50 },
				{ value: 5, min: 50, max: 60 },
				{ value: 10, min: 60, max: 80 },
				{ value: 7.5, min: 80, max: 95 },
				{ value: 0, min: 95, max: 100 },
			],
			weight: 10,
		},
		[SCORING_PARAMETER.PercentageTimeInTheMiddle]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 20 },
				{ value: 2.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 7.5, min: 40, max: 60 },
				{ value: 10, min: 60, max: 100 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.TotalTime]: {
			type: SCORING_TYPE.Time,
			ranges: [
				{ value: 10, min: 0, max: 20 },
				{ value: 7.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 0, min: 40, max: 60 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.TotalTries]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 10, min: 1, max: 1 },
				{ value: 5, min: 1, max: 2 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.NoseDistance]: {
			type: SCORING_TYPE.Pixel,
			ranges: [
				{ value: 0, min: 0, max: 70 },
				{ value: 7.5, min: 70, max: 90 },
				{ value: 10, min: 90, max: 130 },
				{ value: 7.5, min: 130, max: 150 },
				{ value: 5, min: 150, max: null },
			],
			weight: 20,
		},
		[SCORING_PARAMETER.NoseTransition]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 0, min: 0, max: 4 },
				{ value: 5, min: 4, max: 7 },
				{ value: 10, min: 7, max: 10 },
			],
			weight: 15,
		},
		[SCORING_PARAMETER.NoseVariance]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 60 },
				{ value: 7.5, min: 60, max: 75 },
				{ value: 10, min: 75, max: 100 },
			],
			weight: 20,
		},
	},
	[LIFE_TEST_ID.LIFTHEAD]: {
		[SCORING_PARAMETER.Emotion]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 30 },
				{ value: 7.5, min: 30, max: 40 },
				{ value: 10, min: 40, max: 75 },
				{ value: 5, min: 75, max: 100 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.MaxEmotion]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 50 },
				{ value: 10, min: 50, max: 75 },
				{ value: 7.5, min: 75, max: 100 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.EmotionTransition]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 0, min: 0, max: 4 },
				{ value: 5, min: 4, max: 7 },
				{ value: 10, min: 7, max: 10 },
			],
			weight: 10,
		},
		[SCORING_PARAMETER.SimilarityPercentage]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 50 },
				{ value: 5, min: 50, max: 60 },
				{ value: 10, min: 60, max: 80 },
				{ value: 7.5, min: 80, max: 95 },
				{ value: 0, min: 95, max: 100 },
			],
			weight: 10,
		},
		[SCORING_PARAMETER.PercentageTimeInTheMiddle]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 20 },
				{ value: 2.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 7.5, min: 40, max: 60 },
				{ value: 10, min: 60, max: 100 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.TotalTime]: {
			type: SCORING_TYPE.Time,
			ranges: [
				{ value: 10, min: 0, max: 20 },
				{ value: 7.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 0, min: 40, max: 60 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.TotalTries]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 10, min: 1, max: 1 },
				{ value: 5, min: 1, max: 2 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.NoseDistance]: {
			type: SCORING_TYPE.Pixel,
			ranges: [
				{ value: 0, min: 0, max: 70 },
				{ value: 7.5, min: 70, max: 90 },
				{ value: 10, min: 90, max: 130 },
				{ value: 7.5, min: 130, max: 150 },
				{ value: 5, min: 150, max: null },
			],
			weight: 20,
		},
		[SCORING_PARAMETER.NoseTransition]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 0, min: 0, max: 4 },
				{ value: 5, min: 4, max: 7 },
				{ value: 10, min: 7, max: 10 },
			],
			weight: 15,
		},
		[SCORING_PARAMETER.NoseVariance]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 60 },
				{ value: 7.5, min: 60, max: 75 },
				{ value: 10, min: 75, max: 100 },
			],
			weight: 20,
		},
	},
	[LIFE_TEST_ID.LOWERHEAD]: {
		[SCORING_PARAMETER.Emotion]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 30 },
				{ value: 7.5, min: 30, max: 40 },
				{ value: 10, min: 40, max: 75 },
				{ value: 5, min: 75, max: 100 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.MaxEmotion]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 50 },
				{ value: 10, min: 50, max: 75 },
				{ value: 7.5, min: 75, max: 100 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.EmotionTransition]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 0, min: 0, max: 4 },
				{ value: 5, min: 4, max: 7 },
				{ value: 10, min: 7, max: 10 },
			],
			weight: 10,
		},
		[SCORING_PARAMETER.SimilarityPercentage]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 50 },
				{ value: 5, min: 50, max: 60 },
				{ value: 10, min: 60, max: 80 },
				{ value: 7.5, min: 80, max: 95 },
				{ value: 0, min: 95, max: 100 },
			],
			weight: 10,
		},
		[SCORING_PARAMETER.PercentageTimeInTheMiddle]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 20 },
				{ value: 2.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 7.5, min: 40, max: 60 },
				{ value: 10, min: 60, max: 100 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.TotalTime]: {
			type: SCORING_TYPE.Time,
			ranges: [
				{ value: 10, min: 0, max: 20 },
				{ value: 7.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 0, min: 40, max: 60 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.TotalTries]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 10, min: 1, max: 1 },
				{ value: 5, min: 1, max: 2 },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.NoseDistance]: {
			type: SCORING_TYPE.Pixel,
			ranges: [
				{ value: 0, min: 0, max: 70 },
				{ value: 7.5, min: 70, max: 90 },
				{ value: 10, min: 90, max: 130 },
				{ value: 7.5, min: 130, max: 150 },
				{ value: 5, min: 150, max: null },
			],
			weight: 20,
		},
		[SCORING_PARAMETER.NoseTransition]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 0, min: 0, max: 4 },
				{ value: 5, min: 4, max: 7 },
				{ value: 10, min: 7, max: 10 },
			],
			weight: 15,
		},
		[SCORING_PARAMETER.NoseVariance]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 60 },
				{ value: 7.5, min: 60, max: 75 },
				{ value: 10, min: 75, max: 100 },
			],
			weight: 20,
		},
	},
	[LIFE_TEST_ID.GENERAL]: {
		[SCORING_PARAMETER.Emotion]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 20 },
				{ value: 5, min: 20, max: 40 },
				{ value: 10, min: 40, max: 60 },
				{ value: 5, min: 60, max: 70 },
				{ value: 0, min: 70, max: 100 },
			],
			weight: 10,
		},
		[SCORING_PARAMETER.BlinksByMin]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 0, min: 0, max: 3 },
				{ value: 7.5, min: 3, max: 5 },
				{ value: 10, min: 5, max: 9 },
				{ value: 7.5, min: 9, max: 14 },
				{ value: 5, min: 14, max: 18 },
				{ value: 0, min: 18, max: null },
			],
			weight: 5,
		},
		[SCORING_PARAMETER.SimilarityPercentage]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 50 },
				{ value: 5, min: 50, max: 60 },
				{ value: 10, min: 60, max: 80 },
				{ value: 7.5, min: 80, max: 95 },
				{ value: 0, min: 95, max: 100 },
			],
			weight: 15,
		},
		[SCORING_PARAMETER.PercentageTimeInTheMiddle]: {
			type: SCORING_TYPE.Percentage,
			ranges: [
				{ value: 0, min: 0, max: 20 },
				{ value: 2.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 7.5, min: 40, max: 60 },
				{ value: 10, min: 60, max: 100 },
			],
			weight: 10,
		},
		[SCORING_PARAMETER.TotalTries]: {
			type: SCORING_TYPE.Count,
			ranges: [
				{ value: 10, min: 1, max: 1 },
				{ value: 7.5, min: 1, max: 2 },
				{ value: 5, min: 2, max: 3 },
				{ value: 0, min: 3, max: null },
			],
			weight: 10,
		},
		/*
		 * Multiplicar los tiempos por el Nº pruebas * Nº intentos
		 */
		[SCORING_PARAMETER.TotalTime]: {
			type: SCORING_TYPE.Time,
			ranges: [
				{ value: 10, min: 0, max: 20 },
				{ value: 7.5, min: 20, max: 30 },
				{ value: 5, min: 30, max: 40 },
				{ value: 0, min: 40, max: null },
			],
			weight: 10,
		},
		[SCORING_PARAMETER.LifeTests]: {
			type: SCORING_TYPE.Percentage,
			ranges: [],
			weight: 40,
		},
	},
};
